import React from 'react';

import { capitalize } from 'lodash/fp';

import useBuildInfoStore from '@/hooks/useBuildInfo';

import BuildDetailsGrid, { BuildDetailsGridLabelValuePair } from './components/BuildDetailsGrid';

const BuildDetailsInfoContractModules: React.FC = () => {
  const { buildInfo } = useBuildInfoStore();

  if (!buildInfo) {
    return null;
  }

  const contractModulesInfo = Object.entries(buildInfo).reduce((acc, cur) => {
    const [key, value] = cur;
    if (value && key.endsWith('.cm')) {
      return acc.set(key, value as unknown as { version: string });
    }
    return acc;
  }, new Map<string, { version: string }>());

  return (
    <ul>
      {[...contractModulesInfo.entries()].map(([key, value]) => {
        return (
          <li key={key}>
            <BuildDetailsGrid>
              <BuildDetailsGridLabelValuePair label={capitalize(key)} value={value.version} />
            </BuildDetailsGrid>
          </li>
        );
      })}
    </ul>
  );
};

export default BuildDetailsInfoContractModules;
